<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :show-close="false"
    center
    width="40%"
  >
    <dialog-header
      slot="title"
      :title="!isEdit? $t('system.user.createAndUpdate.create'):$t('system.user.createAndUpdate.update')"
      :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle style="padding-top:10px">
      <el-row type="flex" justify="center" align="top">
        <el-col :span="24">
          <el-form ref="form" size="mini" :model="formInfo" :rules="rules" :label-position="'right'" 
          :label-width="$t('system.user.labelWidth')">
            <el-form-item :label="$t('system.user.loginAccount') + '：'" prop="loginName">
              <el-input v-model="formInfo.loginName" :maxlength="50" :placeholder="$t('system.user.loginAccount')" clearable  />
            </el-form-item>
            <el-form-item :label="$t('system.user.userName') + '：'" prop="realName">
              <el-input v-model="formInfo.realName" :maxlength="50" :placeholder="$t('system.user.userName')" clearable  />
            </el-form-item>

            <el-form-item :label="$t('public.mobile') + '：'" prop="phoneNumber">
              <el-input 
              @keydown.native="inputLimit" 
              oninput="if(value.length>15)value=value.slice(0,15)"
              v-model="formInfo.realMobile" 
              :placeholder="$t('public.mobile')"
              clearable />
            </el-form-item>

            <el-form-item v-show="!isEdit" :label="$t('system.user.accountStatus') + '：'" required>
              <el-radio-group v-model="formInfo.isDisabled">
                <el-radio :label="1">
                  {{ $t('system.user.ban') }}
                </el-radio>
                <el-radio :label="0">
                  {{ $t('system.user.enable') }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('system.user.role') + '：'" prop="roleId">
              <el-select
                v-model="formInfo.roleId"
                :placeholder="$t('system.user.role')"
                filterable
                clearable
              >
                <el-option
                  v-for="(item,index) in v2xList"
                  :key="index"
                  :label="item.roleName"
                  :value="item.roleId"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('public.note') + '：'">
              <el-input
                v-model="formInfo.remark"
                :rows="3"
                :autosize="{ minRows: 3, maxRows: 3}"
                resize="none"
                :placeholder="$t('public.note')"
                type="textarea"
                :maxlength="500"
                :show-word-limit="true"/>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </vue-linetitle>
    <div style="height:8px"></div>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handlecancle">{{$t('public.cancel')}}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{$t('public.define')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
// request
import { getRoleV2xList } from '@/api/system/role'
import { createUser, updateUser } from '@/api/system/user'
// 混入
import { partialForm } from '@/mixins/partialForm'
export default {
  name: 'AddUpdateDialog',
  // components: { appOrganizePicker },
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    mobile: {
      type: String,
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    }
  },
  data() {
    // 登录账号
    const loginName = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.user.createAndUpdate.msg.error1')))
      }
    }
    // 真实姓名
    const realName = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.user.createAndUpdate.msg.error2')))
      }
    }
    //
    const roleId = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('system.user.createAndUpdate.msg.error3')))
      }
    }
 
    // 手机号验证
    // const mobile = (rule, value, cb) => {
    //   if (!value) {
    //     return cb(new Error(this.$t('输入手机号')))
    //   }
    // }
    return {
      v2xList: [],
      defaultFormInfo: {
        isDisabled: 0
      },
      formInfo: {},
      rules: {
        loginName: [
          { required: true, trigger: ['blur','change'], validator: loginName }
        ],
        realName: [
          { required: true, trigger: ['blur','change'], validator: realName }
        ],
        roleId: [
          { required: true, trigger: ['blur','change'], validator: roleId }
        ]
        // mobile: [
        //   { required: true, trigger:['blur','change'], validator: mobile }
        // ]
      }
    }
  },
  watch: {
    visibles: {
      handler(e1) {
        if (e1) {
          this.v2xList.length ===0 && this.getRoleV2xList()
          
          this.formInfo = { ...this.defaultFormInfo, ...this.data }
        }
      }
    }
  },
  created(){
    this._getV2xRoleList()
  },
  methods: {
    inputLimit(e){
      let key = e.key
      // 不允许输入'e'和'.'、'+'、'-'、'Shift'
      if (key === 'e' || key === '.' || key === '+' || key === '-' || key === 'Shift' ) {
      e.returnValue = false
      return false
      }
      
      return true
    },
    _getV2xRoleList() {
      getRoleV2xList().then(({data})=> {
        if(data.code===0) {
          this.v2xList = data.data || []
        }
      })
    },
    // 关闭dialog
    closeDialog() {
      this.formInfo = {...this.defaultFormInfo}
      this.$emit('update:visibles', false)
    },
    // 点击取消
    handlecancle() {
      this.closeDialog()
    },
    // 点击确定
    handleSubmit(){
      let check = this.checkForm({ formName: 'form',
          formList: ['loginName','realName','roleId'] })
      if(!check) return
      // eslint-disable-next-line no-unused-vars
      const { userId, $index,createdOn,roleName,sex,...postData } = this.formInfo
      postData.mobile=postData.realMobile
      console.log(postData)
      if(!this.isEdit){
        this._createUser(postData)
      }else{
        
        this._updateUser({data: postData, id: userId})
      }
          
    },
  
    // 新增
    _createUser(postData) {
      createUser(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _updateUser(postData) {
      updateUser(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>
<style lang="scss">
// .textareaStyle textarea{
//   height: 80px!important;
// }
</style>
